import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PublicBundle, Vehicle } from '@common/core/models';
import { LeadsService, NewslettersService } from '@common/core/services';
import { EBitfUiMessageType } from '@common/enums';
import { IBitfToastData } from '@common/interfaces';
import { BitfErrorHandlerService } from '@common/libs/bitforce/core/services/error-handler/bitf-error-handler.service';
import { bitfMarkAllFormControlsAsTouched } from '@common/libs/bitforce/utils/bitf-form.utils';
import { bitfValidateEmail } from '@common/libs/bitforce/validators/bitf-email.validator';
import { TranslateService } from '@ngx-translate/core';
import { ToastMessagesService } from '@web/core/services';
@Component({
  selector: 'cci-contacts-form',
  templateUrl: './contacts-form.component.html',
  styleUrls: ['./contacts-form.component.scss'],
})
export class ContactsFormComponent implements OnInit {
  @Input() title: string;
  @Input() subTitle: string;
  @Input() ctaLabel: string;
  @Input() publicBundle?: PublicBundle;
  @Input() vehicle?: Vehicle;
  @Input() messageRequired = true;

  infosForm: FormGroup;
  isMessageSent = false;

  constructor(
    private formBuilder: FormBuilder,
    private newsletterService: NewslettersService,
    private leadsService: LeadsService,
    private toastMessageService: ToastMessagesService,
    private translateService: TranslateService,
    private bitfErrorHandlerService: BitfErrorHandlerService
  ) {}

  ngOnInit(): void {
    this.initForm();
  }

  onSubmit() {
    bitfMarkAllFormControlsAsTouched(this.infosForm);

    const formValue = { ...this.infosForm.value };
    if (!formValue.contactsPolicy) {
      this.toastMessageService.show({
        type: EBitfUiMessageType.ERROR,
        message: this.translateService.instant('COMMON.LABEL.YOU_HAVE_TO_ACCEPT_CONTACTS_POLICY'),
      } as IBitfToastData);
      return;
    }

    if (this.infosForm.valid) {
      formValue.email = formValue.email?.toLowerCase().trim();
      // Store message
      this.leadsService.post({ body: formValue }).subscribe(
        () => {
          this.isMessageSent = true;
          this.infosForm.reset();
        },
        error => {
          this.bitfErrorHandlerService.handleError(error);
          this.toastMessageService.show({
            type: EBitfUiMessageType.ERROR,
            message: this.translateService.instant('COMMON.LABEL.ERROR_SENDING_MESSAGE'),
          } as IBitfToastData);
        }
      );

      if (formValue.newsletterSubscription) {
        // Add newsletter contact
        this.newsletterService
          .post({ body: { email: formValue.email?.toLowerCase().trim(), fullName: formValue.fullName } })
          .subscribe(
            () => {},
            error => {
              this.bitfErrorHandlerService.handleError(error);
              this.toastMessageService.show({
                type: EBitfUiMessageType.ERROR,
                message: this.translateService.instant('COMMON.LABEL.EMAIL_ALREADY_SUBSCRIBED_OR_INVALID'),
              } as IBitfToastData);
            }
          );
      }
    }
  }

  private initForm() {
    this.infosForm = this.formBuilder.group({
      email: ['', [bitfValidateEmail, Validators.required]],
      fullName: [''],
      phoneNumber: [''],
      message: ['', this.messageRequired ? Validators.required : null],
      contactsPolicy: [true],
      newsletterSubscription: [true],
      publicBundle: [this.publicBundle?.id],
      garage: [this.vehicle?.id],
    });
  }
}
